import { styled } from '@mui/material/styles';

const StyledNavLinks = styled('nav')`
  display: flex;
  align-items: center;
  gap: 2rem;

  a {
    text-transform: uppercase;
    text-decoration: none;
    color: #000;
  }
`;

export default StyledNavLinks;
